export const information = {
  site: "thai_789bet",
  cskh_url: "https://7893231.com",
  cskh_home: "https://7893231.com",
  endpoint: "https://api-code-thai789bet.freecodevip.org",
  //endpoint: "http://localhost:5039",
  key_free: "att.code.hau-dai.thai_789-bet@2030$",
};
